import { client } from '@/lib/typesense';
import {
  SearchParams,
  SearchResponse,
  SearchResponseHit,
} from 'typesense/lib/Typesense/Documents';

interface ProductDocument {
  product_title: string;
  product_handle: string;
  product_thumbnail: string;
  variant_price: number;
  variant_sku: string;
  search_metadata?: string;
  product_key_features?: string;
  product_description?: string;
}

export const getSearchProducts = async (query: string, region: string) => {
  try {
    const searchParameters: SearchParams = {
      q: query,
      query_by:
        'product_title,search_metadata,variant_sku,search_metadata_arr,product_key_features,product_description',
      query_by_weights: '3,2,1,1,1,1',
      num_typos: 2,
      per_page: 100,
      split_join_tokens: 'always',
      infix: 'fallback',
      ...(region && { filter_by: `region:=${region}` }),
    };

    const results = (await client
      .collections('products')
      .documents()
      .search(searchParameters)) as SearchResponse<ProductDocument>;

    // Group by product_handle
    const grouped: Record<
      string,
      {
        title: string;
        handle: string;
        thumbnail: string;
        prices: number[];
      }
    > = {};

    results?.hits &&
      results?.hits.forEach((hit: SearchResponseHit<ProductDocument>) => {
        const doc = hit.document;
        const handle = doc.product_handle;

        if (!grouped[handle]) {
          grouped[handle] = {
            title: doc.product_title,
            handle: doc.product_handle,
            thumbnail: doc.product_thumbnail,
            prices: [],
          };
        }

        grouped[handle].prices.push(doc.variant_price);
      });

    // Format final result
    const formattedResults = Object.values(grouped).map((product) => {
      const prices = product.prices.sort((a, b) => a - b);
      const rrp =
        prices[0] === prices[prices.length - 1]
          ? `${parseFloat(prices[0].toString()).toFixed(2)}`
          : `${prices[0]} - ${prices[prices.length - 1]}`;

      return {
        title: product.title,
        handle: product.handle,
        thumbnail: product.thumbnail,
        rrp,
      };
    });

    return formattedResults;
  } catch (error) {
    console.error('Error searching products:', error);
    return [];
  }
};
